export const UPDATE_DMX_CONTROLLER = 'UPDATE_DMX_CONTROLLER';
export const UPDATE_DMX_CONTROLLER_SUCCESSFUL = 'UPDATE_DMX_CONTROLLER_SUCCESSFUL';
export const UPDATE_DMX_CONTROLLER_FAILED = 'UPDATE_DMX_CONTROLLER_FAILED';
